/* istanbul ignore file */
import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import { RequestType } from './oneStopTypes';
import Box from '@mui/material/Box';

export type ModalData = {
  isOpen: boolean;
  title: string | undefined;
  content: string | React.ReactElement;
  requestId?: string | null;
  requestType?: RequestType | null;
};

type OneStopModalLayoutProps = {
  modalConfirmHandler: () => void;
  modalData: Nullable<ModalData>;
};

const OneStopModalLayout = ({ modalConfirmHandler, modalData }: OneStopModalLayoutProps) => {
  const { isOpen = false, title, content } = modalData || {};

  return (
    <Modal
      isOpen={isOpen}
      onToggle={modalConfirmHandler}
      title={title}
      hasCancelButton={false}
      buttons={[
        <Button key="ok-btn" onClick={modalConfirmHandler}>
          OK
        </Button>,
      ]}
      className="onestop-modal-window"
      modalSize="sm"
      hasCloseIcon
    >
      <Box sx={{ textAlign: 'center' }}>{content}</Box>
    </Modal>
  );
};

export default OneStopModalLayout;
